export default {
  mounted() {
    const handle = this.el.querySelector("[data-resize-handle]")
    if (!handle) return

    const minWidth = parseInt(this.el.style.minWidth) || 280
    const maxWidth = parseInt(this.el.style.maxWidth) || 600

    let startX, startWidth

    const onMove = (e) => {
      const delta = startX - e.clientX
      const newWidth = Math.max(minWidth, Math.min(maxWidth, startWidth + delta))
      this.el.style.width = newWidth + "px"
    }

    const onUp = () => {
      document.removeEventListener("mousemove", onMove)
      document.removeEventListener("mouseup", onUp)
      document.body.style.cursor = ""
      document.body.style.userSelect = ""
    }

    handle.addEventListener("mousedown", (e) => {
      e.preventDefault()
      startX = e.clientX
      startWidth = this.el.offsetWidth
      document.body.style.cursor = "col-resize"
      document.body.style.userSelect = "none"
      document.addEventListener("mousemove", onMove)
      document.addEventListener("mouseup", onUp)
    })
  }
}
